/* Mobile only: hide the product gallery thumbnail strip once the
   user scrolls to engage with the personalization area, reveal it
   when scrolling back up toward the gallery. Frees vertical space
   for the personalization fields below the sticky gallery wrapper.

   Trigger: position of the personalization root in the viewport.
   - Customall: .ctm-customize-product
   - Customily: #cl_optionsapp

   Anti-jump: instant display:none (no CSS transition). Browser's
   built-in scroll anchoring (overflow-anchor: auto) keeps visible
   content stable when the sticky wrapper shrinks.

   CSS specificity note: customall.css has
     #artwork-preview ~ media-gallery slider-component[id^="GalleryThumbnails"]
     { display: block !important; }
   which forces visibility on Customall. We beat it with a selector
   of specificity 1,2,2 (adds .thumbs-autohidden class). */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function injectStyles() {
    if (document.getElementById('thumb-autohide-style')) return;
    var s = document.createElement('style');
    s.id = 'thumb-autohide-style';
    s.textContent =
      '@media (max-width: 749px) {' +
      '  body { overflow-anchor: auto; }' +
      '  media-gallery slider-component[id^="GalleryThumbnails"].thumbs-autohidden,' +
      '  #artwork-preview ~ media-gallery slider-component[id^="GalleryThumbnails"].thumbs-autohidden {' +
      '    display: none !important;' +
      '  }' +
      '}';
    document.head.appendChild(s);
  }

  function bind(thumbs, personalization) {
    var hidden = false;
    var HIDE_AT = 400;
    var SHOW_AT = 550;

    function hide() {
      if (hidden) return;
      thumbs.classList.add('thumbs-autohidden');
      hidden = true;
    }
    function show() {
      if (!hidden) return;
      thumbs.classList.remove('thumbs-autohidden');
      hidden = false;
    }

    var ticking = false;
    function check() {
      ticking = false;
      var top = personalization.getBoundingClientRect().top;
      if (!hidden && top < HIDE_AT) hide();
      else if (hidden && top > SHOW_AT) show();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    check();
  }

  function init() {
    injectStyles();
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      var thumbs = document.querySelector('media-gallery slider-component.thumbnail-slider');
      var personalization = document.querySelector('.ctm-customize-product, #cl_optionsapp');
      if (thumbs && personalization) {
        clearInterval(iv);
        bind(thumbs, personalization);
      } else if (attempts > 40) {
        clearInterval(iv);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
